'use client';

import { useParams } from 'next/navigation';
import { parseUserAgent } from '@diritto/common/utils/userAgent';
import { useInAppState } from 'contexts/InAppProvider';
import { SectionPage } from 'app/(appHeader)/sections/[sectionSlug]/SectionPage';

export default function Page() {
  const { userAgent } = useInAppState();
  const { isApp } = parseUserAgent(userAgent ?? '');
  const params = useParams();
  const sectionSlug = (params?.sectionSlug as string) ?? '';
  return <SectionPage sectionSlug={sectionSlug} isApp={isApp} />;
}
